import { type FC } from 'react';
import BrokenImageIcon from 'dibs-icons/exports/legacy/BrokenImage';
import { Spinner } from 'dibs-elements/exports/Spinner';

import styles from './styles/NftItemTileMediaUnavailable.scss';

export const NftItemTileMediaUnavailable: FC<{ showSpinner?: boolean }> = ({ showSpinner }) => (
    <div className={styles.container}>
        {showSpinner ? (
            <Spinner containerClass={styles.icon} black />
        ) : (
            <BrokenImageIcon className={styles.icon} />
        )}
    </div>
);
